import React, { useEffect, useState} from 'react'
import axios from 'axios';
import Swal from "sweetalert2";
import { FaEdit, FaTimes } from "react-icons/fa";
import './paises_style.css'


function Paises() {
  const [users, setUsers] = useState([])
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [loading, setLoading] = useState(true)
  const [searchValue, setSearchValue] = useState("");
  
  const getUsers = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/country`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
        },
      });
      if (res.data.code === 1){
        setUsers(res.data.users)
        setLoading(false)
      }
      
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
      setLoading(true)
    }
  };
  
  const deleteUser = async ( id ) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });

      if (result.isConfirmed) {
        const idRegex = /^[a-zA-Z0-9_-]+$/;
        if (!idRegex.test(id)) throw new Error("Invalid Resource Identifier");
        const baseUrl = process.env.REACT_APP_URL_BACKEND;
        if (!baseUrl.startsWith('https:')) throw new Error("Insecure Connection");
        const safeId = encodeURIComponent(id);
        const token = localStorage.getItem("token")?.replace(/[\r\n]/g, "");
        await axios.delete(`${baseUrl}/country/${safeId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        Swal.fire("¡Eliminado!", "El país ha sido eliminado.", "success");
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          "Cancelado",
          "Tu país está a salvo :)",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  }
  
  const updateUser = async (id) => {
    try {
      const idRegex = /^[a-zA-Z0-9_-]+$/;
      if (!idRegex.test(id)) throw new Error("Invalid Resource Identifier");
      const baseUrl = process.env.REACT_APP_URL_BACKEND;
      if (!baseUrl.startsWith('https:')) throw new Error("Insecure Connection");
      const safeId = encodeURIComponent(id);
      const token = localStorage.getItem("token")?.replace(/[\r\n]/g, "");
      const response = await axios.get(`${baseUrl}/country/${safeId}`, {
        headers: { Authorization: `Bearer ${token}` }
      }); 
      const userData = response.data.user;
      // console.log(response)
      const result = await Swal.fire({
        title: "Editar País",
        html:
          '<div class="form-grid">' +
          `<input type="text" id="name" class="swal2-input" placeholder="Pepito Perez" value="${userData[0].name}">` +
          `<input type="hidden" id="id" class="swal2-input" placeholder="Pepito Perez" value="${userData[0].id}">` +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Actualizar",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          return new Promise(function (resolve) {
            resolve({
              name: document.getElementById("name").value,
              id: document.getElementById("id").value,
            });
          });
        },
      });

      if (result.isConfirmed) {
        const updatedUserData = result.value;
        // Realizar la solicitud PUT al servidor para actualizar el usuario
        const updateResponse = await axios.put(
          `${process.env.REACT_APP_URL_BACKEND}/country/update`,
          updatedUserData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`, // Agrega el token de sesión en los encabezados con el formato "Bearer {token}"
            },
          }
        );
        Swal.fire(
          "¡Actualizado!",
          "El país ha sido actualizado exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          "Cancelado",
          "No se ha realizado ninguna actualización.",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };
  
  const createUser = async () => {
    try {
      const result = await Swal.fire({
        title: "Crear País",
        html:
          '<div class="form-grid">' +
          '<input type="text" id="name" class="swal2-input" placeholder="País">' +
          "</div>",
        showCancelButton: true,
        confirmButtonText: "Crear",
        cancelButtonText: "Cancelar",
        preConfirm: function () {
          return new Promise(function (resolve) {
            resolve({
              name: document.getElementById("name").value,
            });
          });
        },
      });
  
      if (result.isConfirmed) {
        const userData = result.value;
  
        const response = await axios.post(
          `${process.env.REACT_APP_URL_BACKEND}/country/create`,
          userData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        Swal.fire(
          "¡Creado!",
          "El país ha sido creado exitosamente.",
          "success"
        );
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado", "Accion cancelada.", "error");
      }
    } catch (error) {
      if (error.response.data.message === "El país ya existe") {
        Swal.fire("Error al crear el país", "El país ya existe.", "error");
      } else if (error.response.data.message === "El país fue eliminado anteriormente") {
        Swal.fire("Error al crear el país", "El país fue eliminado anteriormente", "error");
      } else if (error.response.data.errors[0] === "La contraseña debe ser mayor a 6 caracteres") {
        Swal.fire("Error al crear el país", "La contraseña debe ser mayor a 6 caracteres", "error");
      } else if (error.response.data.errors[0] === "El formato del correo no es valido") {
        Swal.fire("Error al crear el país", "El formato del correo no es valido", "error");
      } else {
        Swal.fire(
          "Error al crear el país",
          "No se ha creado ningún país."
        );
      }
    }
  };
  
  const handleSearch = () => {
    const input = document.getElementById("searchInput");
    setSearchValue(input.value.trim());
  };
  
  const filteredUsers = searchValue
  ? users.filter(
      (user) =>
        user.name
          .toUpperCase()
          .includes(searchValue.toUpperCase()) ||
        user.email.toUpperCase().includes(searchValue.toUpperCase())
    )
  : users

  useEffect(() => {
    getUsers();
  }, [updateTrigger]);

  return (
    <>
    <div className="panel-table">
    <div className='colum-left'>
      <input type="text" className='searchInput' id="searchInput" placeholder="Buscar..." />
      <button className='btnn' onClick={handleSearch}>Buscar</button>
    </div>
    <div className='colum-rigth'>
      <button className="btnn" onClick={createUser}>
        Crear País
      </button>
    </div>
    </div>
    <div className='table-responsive'>
      <table className='table table-preve' id='tableToSearch'>
        <thead>
          <tr>
            <th>Nombre</th>
            <td className='accions'>Acciones</td>
          </tr>
        </thead>
        
        <tbody>
        {loading ? (<tr><td>Cargando...</td></tr>) : 
        ( filteredUsers.map((user) => (
          <tr key={user.id} data-master-id={user.id}>
            <td>{user.name}</td>
            <td>
            <FaEdit className='editButton' onClick={() =>{ updateUser(user.id)}}/>
            <FaTimes className='deleteButton' onClick={() =>{ deleteUser(user.id)}}/>
            </td>
          </tr>
        )))}
        </tbody>
      </table>
    </div>
    </>
  )
}

export default Paises